import React from 'react';
import Typography from '@material-ui/core/Typography';
import SkeletonWrapper from '../../afw/components/SkeletonWrapper/SkeletonWrapper';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';

const styles = theme => ({
  StandardGalleryRoot: {
    height: '620px',
    [theme.breakpoints.down('sm')]: {
      height: '150px'
    },
    backgroundColor: "#888", 
    width: '100%'
  },
  EmergencyBroadcastRoot:{
    padding: '25px 40px',
    backgroundColor: '#888'
  },
  ToolbarRoot:{
    height: '50px', 
    width: '100%', 
    background: "#888"
  },
  ResizeGridRoot:{
    width: 'calc(33% - 10px)',
    display: 'inline-block',
    textAlign: 'center',
    overflow: 'hidden',
    // borderRadius: '5px',
    margin: '6px',
    // border: '2px solid white',
    [theme.breakpoints.down('md')]: {
      width: '33%'
    },
    [theme.breakpoints.down('sm')]: {
      width: 'calc(50% - 12px)'
    },
    [theme.breakpoints.down('xs')]: {
      width: 'calc(100% - 12px)'
    },
  },
  ResizeGridImg: {
    height: '300px',
    width: '100%',
    position: 'relative',
    background: '#888'
  },
  NewsReleaseRoot:{
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap'
  },
  NewsReleaseChild:{
    flex: '1 1 300px',
    minWidth: '300px',
    margin: '10px'
  },
  NewsReleaseFill:{
    background: '#888', 
    height: '80px', 
    width: '100%', 
    margin: '10px'
  },
  VideoEmbedRoot: {
    height: '349px', 
    width: '75%', 
    background: 'rgb(200,200,200)', 
    margin: 'auto'
  },
  BioRoot:{
    padding: '80px',
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      padding: '40px',
    },
    [theme.breakpoints.down('xs')]: {
      padding: '0px',
    },
    background: '#888'
  },
  BioPaper: {
    position: 'relative', 
    boxShadow: '17px 20px 26px 0px rgba(0,0,0,0.5)',
    background: '#fff',
    borderRadius: '5px',
    width: '100%',
    height: '150px',
    margin: '20px'
  }
})

function Fallback(props){
  const {classes} = props;
  const fallbacks = {
    StandardGallery: (
      <div className={classes.StandardGalleryRoot}></div>
    ),
    Toolbar: (
      <div className={classes.ToolbarRoot}></div>
    ),
    EmergencyBroadcast: (
      <div className={classes.EmergencyBroadcastRoot}></div>
    ),
    ResizeGrid: (
      <div>
        <div className={`${classes.ResizeGridRoot}`}>
          <div className={`${classes.ResizeGridImg}`}></div>
        </div>
        <div className={`${classes.ResizeGridRoot}`}>
          <div className={`${classes.ResizeGridImg}`}></div>
        </div>
        <div className={`${classes.ResizeGridRoot}`}>
          <div className={`${classes.ResizeGridImg}`}></div>
        </div>
        <div className={`${classes.ResizeGridRoot}`}>
          <div className={`${classes.ResizeGridImg}`}></div>
        </div>
        <div className={`${classes.ResizeGridRoot}`}>
          <div className={`${classes.ResizeGridImg}`}></div>
        </div>
        <div className={`${classes.ResizeGridRoot}`}>
          <div className={`${classes.ResizeGridImg}`}></div>
        </div>
      </div>
    ),
    NewsRelease: (
      <div className={classes.NewsReleaseRoot}>
        <div className={classes.NewsReleaseChild}>
          <div className={classes.NewsReleaseFill}></div>
          <div className={classes.NewsReleaseFill}></div>
          <div className={classes.NewsReleaseFill}></div>
          <div className={classes.NewsReleaseFill}></div>
          <div className={classes.NewsReleaseFill}></div>
        </div>
        <div className={classes.NewsReleaseChild}>
          <div className={classes.NewsReleaseFill}></div>
          <div className={classes.NewsReleaseFill}></div>
          <div className={classes.NewsReleaseFill}></div>
          <div className={classes.NewsReleaseFill}></div>
          <div className={classes.NewsReleaseFill}></div>
        </div>
      </div>
    ),
    ImageBox: (
      <div>
        <div className={`${classes.ResizeGridRoot}`}>
          <div className={`${classes.ResizeGridImg}`}></div>
        </div>
        <div className={`${classes.ResizeGridRoot}`}>
          <div className={`${classes.ResizeGridImg}`}></div>
        </div>
        <div className={`${classes.ResizeGridRoot}`}>
          <div className={`${classes.ResizeGridImg}`}></div>
        </div>
        <div className={`${classes.ResizeGridRoot}`}>
          <div className={`${classes.ResizeGridImg}`}></div>
        </div>
        <div className={`${classes.ResizeGridRoot}`}>
          <div className={`${classes.ResizeGridImg}`}></div>
        </div>
        <div className={`${classes.ResizeGridRoot}`}>
          <div className={`${classes.ResizeGridImg}`}></div>
        </div>
      </div>
    ),
    VideoEmbed: (
      <div className={classes.VideoEmbedRoot}></div>
    ),
    Bio: (
      <div className={classes.BioRoot}>
        <div className={classes.BioPaper}></div>
        <div className={classes.BioPaper}></div>
        <div className={classes.BioPaper}></div>
      </div>
    )
  };
  if(!props.component || !fallbacks[props.component] ){
    const panels = [0,0,0];
    return (
      <div>
        {panels.map((_,i)=>
          <div key={i}>
            <SkeletonWrapper loading={true}>
              <div style={{borderRadius: '50%', width: '20px', height: '20px', margin: '20px', display: 'inline-block'}}></div>
              <Typography variant="h6" style={{width: 'calc(100% - 100px)', display: 'inline-block'}}>Loading Data</Typography>
            </SkeletonWrapper>
          </div>
        )}
      </div>
    )
  }else{
    return fallbacks[props.component];
  }
};

Fallback.propTypes = {
  classes: PropTypes.object.isRequired,
};
export default withStyles(styles)(Fallback);